import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import baseURL from "../../../../configs/api";
import Cookies from "js-cookie";
import DOMPurify from "dompurify";

interface EmailDetails {
    id: number;
    htmlBody: string;
}

export default function ViewEmailBody() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [email, setEmail] = useState<EmailDetails | null>(null);
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";

    useEffect(() => {
        if (!id) {
            navigate("*");
            return;
        }

        fetch(`${baseURL}emailLogs/GetEmailDetail/${id}`, {
            headers: { "X-Tenant-ID": tenantId },
        })
            .then((res) => {
                return res.json();
            })
            .then((data) => {
                setEmail(data);
            })
            .catch(() => {
                navigate("*", { replace: true });
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    if (!email) return <div className="flex flex-col items-center justify-center h-screen gap-3">
        <div className="animate-spin h-10 w-10 border-4 border-gray-300 border-t-blue-600 rounded-full" />
        <p className="text-gray-600">Loading email…</p>
    </div>;

    return (
        <div className="p-4">
            <h2 className="text-lg font-semibold mb-4">Email Preview</h2>

            <div
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(email.htmlBody) }}
                className="border p-4 rounded bg-white"
            />
        </div>
    );
}
